import { AgreementType } from 'fitbeat.models';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { View, Text, ScrollView, SafeAreaView } from 'react-native';
import { Button, TextInput, FormHeader, Heading, FormKeyboardSpacer } from 'fitbeat.react-native-components';
import { setGuardianInformation } from './actions';
import { styles } from './SignupFormsStyles';
import GuardianFields from './GuardianFields';
import { OnBoardingProgress } from './components';
import Theme from '../theme';
class GuardianConsentScreen extends Component {
  constructor(props) {
    super(props);

    const { guardianInfo = {} } = this.props.basicUserInfo;
    const initialValues = {
      name: guardianInfo.name,
      lastname: guardianInfo.lastname,
      contactNumber: guardianInfo.contactNumber,
      email: guardianInfo.email,
      address: guardianInfo.address,
    }

    this.state = { initialValues }
  }

  onSubmit = async (formValues) => {
    const agreementSet = [
      AgreementType.Platform,
      AgreementType.Privacy,
      AgreementType.Membership
    ];

    formValues.legalAgreements = agreementSet;
    await this.props.setGuardianInformation(formValues);
    this.props.navigation.navigate('SignUp');
  }

  render() {
    const { t } = this.props;
    const { initialValues } = this.state;

    return (
      <>
      <OnBoardingProgress step={1} progressBarContainer={{ backgroundColor: Theme.GREY_LIGHT }}/>
        <View style={styles.container}>
        <FormKeyboardSpacer>
          <ScrollView
            keyboardShouldPersistTaps="handled"
            showsVerticalScrollIndicator={false}
            contentContainerStyle={styles.scrollViewContainer}>
            <View style={styles.headerContainer}>
              <FormHeader
                style={styles.createAccountHeader}
                title={'Please enter legal guardian\'s info'}
              />
              <Heading
                style={styles.infoText}
                title={'As you are under 18 years old, your legal guardian is required to complete this signup process with you, and join you at the gym when you register for your first class.'}
              />
            </View>

            <GuardianFields
              initialValues={initialValues}
              textInputComponent={TextInput}
              render={({ handleSubmit }) => (
                <View style={styles.footer}>
                  <Text style={styles.message}>{t('noFakeDetails')}</Text>
                  <Button
                    fontColor={Theme.WHITE}
                    containerStyle={{ marginTop: 3 }}
                    onPress={handleSubmit(this.onSubmit)}
                    title={'Proceed'}
                  />
                </View>
              )}
            />
          </ScrollView>
        </FormKeyboardSpacer>
      </View>
        <SafeAreaView style={{flex: 0, backgroundColor: Theme.WHITE}} />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    basicUserInfo: state.auth.initialUserSetup.basicUserInfo,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setGuardianInformation: async (guardianInfo) => {
      dispatch(await setGuardianInformation(guardianInfo))
    },
  };
};

GuardianConsentScreen = translate(['auth', 'formFields'], { wait: true })(GuardianConsentScreen);
GuardianConsentScreen = connect(mapStateToProps, mapDispatchToProps)(GuardianConsentScreen);
export default GuardianConsentScreen;
